module.exports = __webpack_public_path__ + "static/media/esen-colors.120ac12d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/esen-colors.png
// module id = 539
// module chunks = 0